module.exports = __webpack_public_path__ + "static/media/tg-min.95859975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/tg-min.svg
// module id = 694
// module chunks = 0